import {
  Anchor,
  Button,
  Group,
  Paper,
  Stack,
  Text,
  Title,
} from "@mantine/core";
import { useLanguage } from "../../../../../stores/LanguageStore";
import BackButton from "../../../../../components/View/BackButton";
import {
  IconAddressBook,
  IconDeviceFloppy,
  IconExternalLink,
  IconSend,
  IconSpeakerphone,
  IconUsersGroup,
} from "@tabler/icons-react";
import { useFlowStore } from "../../../../../stores/WorkflowStore";
import { Box } from "@mui/material";
import FilterContent from "../../../../../components/Filter/FilterContent";
import { useLeadsStore } from "../../../../../stores/LeadsStore";
import { Link } from "react-router-dom";

const NurturingReview = ({ nurturing, filter, list, setActiveStep }) => {
  const lang = useLanguage((s) => s.language);
  const fields = useLeadsStore((s) => s.filters);
  const nodes = useFlowStore((s) => s.nodes);

  const handleSubmit = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setActiveStep("workflow");
  };

  console.log(nodes);
  

  return (
    <Paper component={Stack} withBorder p={"lg"} gap={"xs"}>
      <Title order={3} ta={"center"}>
        {lang.prm.nurturing.step5.title}
      </Title>

      <Stack
        w="100%"
        component={"form"}
        onSubmit={handleSubmit}
        align="center"
        gap={0}
      >
        <Paper
          px={"md"}
          py={"sm"}
          withBorder
          component={Stack}
          align="center"
          gap={0}
        >
          <Group mb={-16}>
            <IconUsersGroup size={24} />
            <Title order={5}>{lang.prm.nurturing.step5.filter_title}</Title>
          </Group>
          <Box
            sx={{
              "& #filter-apply-button": {
                display: "none",
              },
            }}
          >
            <FilterContent
              fields={fields}
              id={"nurturing-filter"}
              isClient={false}
              pageName={"prm"}
              maxHeight={350}
              mainFilter={filter}
              defaultFiltersClose
              savedFiltersReadonly
              getFieldOptionName={(f) => f.option_name}
              disableEdit={true}
              disableBottomButtons={true}
              disableFilters={true}
            />
          </Box>
        </Paper>

        <Paper
          px={64}
          py={"sm"}
          withBorder
          component={Stack}
          align="center"
          gap={0}
          mt={"md"}
        >
          <Group mb={8}>
            <IconAddressBook size={24} />
            <Title order={5}>{lang.prm.nurturing.step5.list_title}</Title>
          </Group>
          {list?.id ? (
            <Anchor
              component={Link}
              to={`/contact-lists/${list.id}`}
              target="_blank"
            >
              <Group>
                <Text fw={600}>
                  {list.name} #{list.id}
                </Text>
                <IconExternalLink size={16} />
              </Group>
            </Anchor>
          ) : (
            <Text>
              {lang.prm.nurturing.step5.new_list} <b>{list?.name || ""}</b>
            </Text>
          )}
        </Paper>

        {nodes.length > 1 && (
          <Paper
            px={"md"}
            py={"sm"}
            withBorder
            component={Stack}
            align="center"
            gap={0}
            mt={"md"}
          >
            <Group>
              <IconSpeakerphone size={24} />
              <Title order={5}>{lang.prm.nurturing.step5.campaign_title}</Title>
            </Group>
          </Paper>
        )}
      </Stack>

      <Group mt={"md"} gap={"lg"} justify="center">
        <BackButton
          label={lang.global.back}
          onClick={() => setActiveStep("program")}
          size="md"
        />

        <Button
          size="md"
          rightSection={
            nurturing?.id === "create" ? <IconSend /> : <IconDeviceFloppy />
          }
          onClick={() => document.getElementById("nurturing-submit").click()}
        >
          {lang.global.finish}
        </Button>
      </Group>
    </Paper>
  );
};

export default NurturingReview;
